// @tensorflow/tfjs-models Copyright 2019 Google
import { loadGraphModel, util, tensor2d, tensor1d } from "@tensorflow/tfjs";

function __awaiter(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        s(r.next(e));
      } catch (e) {
        i(e);
      }
    }

    function l(e) {
      try {
        s(r.throw(e));
      } catch (e) {
        i(e);
      }
    }

    function s(e) {
      e.done ? o(e.value) : new n(function (t) {
        t(e.value);
      }).then(a, l);
    }

    s((r = r.apply(e, t || [])).next());
  });
}

function __generator(e, t) {
  var n,
      r,
      o,
      i,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: l(0),
    throw: l(1),
    return: l(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function l(i) {
    return function (l) {
      return function (i) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                a.label++, r = i[1], i = [0];
                continue;

              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  a = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }

                if (6 === i[0] && a.label < o[1]) {
                  a.label = o[1], o = i;
                  break;
                }

                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(i);
                  break;
                }

                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            i = t.call(e, a);
          } catch (e) {
            i = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, l]);
    };
  }
}

function __awaiter$1(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        s(r.next(e));
      } catch (e) {
        i(e);
      }
    }

    function l(e) {
      try {
        s(r.throw(e));
      } catch (e) {
        i(e);
      }
    }

    function s(e) {
      e.done ? o(e.value) : new n(function (t) {
        t(e.value);
      }).then(a, l);
    }

    s((r = r.apply(e, t || [])).next());
  });
}

function __generator$1(e, t) {
  var n,
      r,
      o,
      i,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: l(0),
    throw: l(1),
    return: l(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function l(i) {
    return function (l) {
      return function (i) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                a.label++, r = i[1], i = [0];
                continue;

              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  a = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }

                if (6 === i[0] && a.label < o[1]) {
                  a.label = o[1], o = i;
                  break;
                }

                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(i);
                  break;
                }

                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            i = t.call(e, a);
          } catch (e) {
            i = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, l]);
    };
  }
}

var stringToChars = function stringToChars(e) {
  for (var t = [], n = 0, r = e; n < r.length; n++) {
    var o = r[n];
    t.push(o);
  }

  return t;
},
    TrieNode = function () {
  function e(e) {
    this.key = e, this.parent = null, this.children = {}, this.end = !1;
  }

  return e.prototype.getWord = function () {
    for (var e = [], t = this; null !== t;) {
      null !== t.key && e.unshift(t.key), t = t.parent;
    }

    return [e, this.score, this.index];
  }, e;
}(),
    Trie = function () {
  function e() {
    this.root = new TrieNode(null);
  }

  return e.prototype.findAllCommonPrefixes = function (e, t, n) {
    if (t.end) {
      var r = t.getWord();
      e.slice(0, r[0].length).join("") === r[0].join("") && n.unshift(r);
    }

    for (var o in t.children) {
      this.findAllCommonPrefixes(e, t.children[o], n);
    }
  }, e.prototype.insert = function (e, t, n) {
    for (var r = this.root, o = stringToChars(e), i = 0; i < o.length; i++) {
      r.children[o[i]] || (r.children[o[i]] = new TrieNode(o[i]), r.children[o[i]].parent = r), r = r.children[o[i]], i === o.length - 1 && (r.end = !0, r.score = t, r.index = n);
    }
  }, e.prototype.commonPrefixSearch = function (e) {
    var t = this.root.children[e[0]],
        n = [];
    return t ? this.findAllCommonPrefixes(e, t, n) : n.push([[e[0]], 0, 0]), n;
  }, e;
}(),
    separator = "▁";

function processInput(e) {
  var t = e.normalize("NFKC");
  return separator + t.replace(/ /g, separator);
}

var RESERVED_SYMBOLS_COUNT = 6,
    Tokenizer = function () {
  function e(e) {
    this.vocabulary = e, this.trie = new Trie();

    for (var t = RESERVED_SYMBOLS_COUNT; t < this.vocabulary.length; t++) {
      this.trie.insert(this.vocabulary[t][0], this.vocabulary[t][1], t);
    }
  }

  return e.prototype.encode = function (e) {
    var t = [],
        n = [],
        r = [];
    e = processInput(e);

    for (var o = stringToChars(e), i = 0; i <= o.length; i++) {
      t.push({}), n.push(0), r.push(0);
    }

    for (i = 0; i < o.length; i++) {
      for (var a = this.trie.commonPrefixSearch(o.slice(i)), l = 0; l < a.length; l++) {
        var s = a[l],
            u = {
          key: s[0],
          score: s[1],
          index: s[2]
        };
        null == t[i + (c = s[0].length)][i] && (t[i + c][i] = []), t[i + c][i].push(u);
      }
    }

    for (var c = 0; c <= o.length; c++) {
      for (var h in t[c]) {
        var f = t[c][h];

        for (l = 0; l < f.length; l++) {
          var d = f[l],
              p = d.score + r[c - d.key.length];
          (0 === r[c] || p >= r[c]) && (r[c] = p, n[c] = f[l].index);
        }
      }
    }

    for (var v = [], y = n.length - 1; y > 0;) {
      v.push(n[y]), y -= this.vocabulary[n[y]][0].length;
    }

    var b = [],
        g = !1;

    for (i = 0; i < v.length; i++) {
      var _ = v[i];
      g && 0 === _ || b.push(_), g = 0 === _;
    }

    return b.reverse();
  }, e;
}(),
    BASE_PATH = "https://storage.googleapis.com/tfjs-models/savedmodel/universal_sentence_encoder/";

function loadTokenizer(e) {
  return __awaiter$1(this, void 0, void 0, function () {
    var t;
    return __generator$1(this, function (n) {
      switch (n.label) {
        case 0:
          return [4, loadVocabulary(e)];

        case 1:
          return t = n.sent(), [2, new Tokenizer(t)];
      }
    });
  });
}

function loadVocabulary(e) {
  return void 0 === e && (e = BASE_PATH + "vocab.json"), __awaiter$1(this, void 0, void 0, function () {
    return __generator$1(this, function (t) {
      switch (t.label) {
        case 0:
          return [4, fetch(e)];

        case 1:
          return [2, t.sent().json()];
      }
    });
  });
}

var BASE_PATH$1 = "https://storage.googleapis.com/tfjs-models/savedmodel/toxicity/";

function load$1(e, t) {
  return __awaiter(this, void 0, void 0, function () {
    var n;
    return __generator(this, function (r) {
      switch (r.label) {
        case 0:
          return [4, (n = new ToxicityClassifier(e, t)).load()];

        case 1:
          return r.sent(), [2, n];
      }
    });
  });
}

var ToxicityClassifier = function () {
  function e(e, t) {
    void 0 === e && (e = .85), void 0 === t && (t = []), this.threshold = e, this.toxicityLabels = t;
  }

  return e.prototype.loadModel = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, loadGraphModel(BASE_PATH$1 + "model.json")];
      });
    });
  }, e.prototype.loadTokenizer = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, loadTokenizer()];
      });
    });
  }, e.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e,
          t,
          n,
          r = this;
      return __generator(this, function (o) {
        switch (o.label) {
          case 0:
            return [4, Promise.all([this.loadModel(), this.loadTokenizer()])];

          case 1:
            return e = o.sent(), t = e[0], n = e[1], this.model = t, this.tokenizer = n, this.labels = t.outputs.map(function (e) {
              return e.name.split("/")[0];
            }), 0 === this.toxicityLabels.length ? this.toxicityLabels = this.labels : util.assert(this.toxicityLabels.every(function (e) {
              return r.labels.indexOf(e) > -1;
            }), function () {
              return "toxicityLabels argument must contain only items from the model heads " + r.labels.join(", ") + ", got " + r.toxicityLabels.join(", ");
            }), [2];
        }
      });
    });
  }, e.prototype.classify = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          n,
          r,
          o,
          i,
          a,
          l,
          s = this;
      return __generator(this, function (u) {
        switch (u.label) {
          case 0:
            for ("string" == typeof e && (e = [e]), t = e.map(function (e) {
              return s.tokenizer.encode(e);
            }), n = t.map(function (e, t) {
              return e.map(function (e, n) {
                return [t, n];
              });
            }), r = [], o = 0; o < n.length; o++) {
              r = r.concat(n[o]);
            }

            return i = tensor2d(r, [r.length, 2], "int32"), a = tensor1d(util.flatten(t), "int32"), [4, this.model.executeAsync({
              Placeholder_1: i,
              Placeholder: a
            })];

          case 1:
            return l = u.sent(), i.dispose(), a.dispose(), [2, l.map(function (e, t) {
              return {
                data: e,
                headIndex: t
              };
            }).filter(function (e) {
              return s.toxicityLabels.indexOf(s.labels[e.headIndex]) > -1;
            }).map(function (t) {
              for (var n = t.data.dataSync(), r = [], o = 0; o < e.length; o++) {
                var i = n.slice(2 * o, 2 * o + 2),
                    a = null;
                Math.max(i[0], i[1]) > s.threshold && (a = i[0] < i[1]), r.push({
                  probabilities: i,
                  match: a
                });
              }

              return {
                label: s.labels[t.headIndex],
                results: r
              };
            })];
        }
      });
    });
  }, e;
}();

export { load$1 as load, ToxicityClassifier };